import dayjs from 'dayjs'
import { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import {
  acceptBookingRequestFuncForMentor,
  rejectBookingRequestFuncForMentor,
} from 'src/consumer/services/featureServices'
import {
  getImageLink,
  getInitialsForChat,
  isCommonResponseSuccessful,
} from 'src/mentor/helpers/utilityFunctions'
import {
  MBRActionbutton,
  MBRActionbuttonContainer,
  MBRItemContainer,
  MBRItemInternalContainer,
  MBRItemLogoImage,
} from './MBRPStyles'
import { BOOKING_REQUEST_STATUS, GENDER_LIST_OFFLINE, currency_list } from 'src/consumer/constants'
import { ChatAvatarContainer } from 'src/components/ChatUIComponents/ChatStyles'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { Spinner } from 'react-bootstrap'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { useNavigate } from 'react-router-dom'

export const BookingRequestStripForMentor = ({ data, afterAcceptOrRejectFunc }) => {
  const { profileData } = useContext(ProfileContext)
  const navigate = useNavigate()
  const [rejectLoading, setRejectLoading] = useState(false)
  const [acceptLoading, setAcceptLoading] = useState(false)

  async function acceptBookingRequest(bookingRequestId) {
    setAcceptLoading(true)
    const response = await acceptBookingRequestFuncForMentor(bookingRequestId)
    setAcceptLoading(false)
    if (afterAcceptOrRejectFunc) {
      afterAcceptOrRejectFunc()
    }
    if (response.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      const bookedEventData = response?.data?.data?.bookedEvent
      toast.success('Booking accepted successfully.')
      toast.success(
        `Session with ${bookedEventData?.userName} from ${dayjs
          .utc(bookedEventData?.startTime)
          ?.local()
          ?.format('DD MMM, h:mma')} to ${dayjs
          .utc(bookedEventData?.endTime, 'YYYY-MM-DD HH:mm:ss')
          ?.local()
          ?.format('DD MMM, h:mma')}`,
      )
    } else {
      toast.error(response?.data?.message || 'Error')
    }
  }

  async function rejectBookingRequest(bookingRequestId) {
    setRejectLoading(true)
    const response = await rejectBookingRequestFuncForMentor(bookingRequestId)
    setRejectLoading(false)
    if (afterAcceptOrRejectFunc) {
      afterAcceptOrRejectFunc()
    }
    if (response.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      toast.warn('Booking rejected.')
    } else {
      toast.warn(response?.data?.message || 'Error')
    }
  }

  console.log(data)

  return (
    <MBRItemContainer>
      <MBRItemInternalContainer>
        <MBRItemLogoImage bglink={getImageLink()} />

        {/* session type and clinic name */}
        <div style={{ marginTop: '8px' }}>
          <b>{data?.eventType === 'therapy-session' ? 'Therapy Session' : 'Booking Request'}</b>
        </div>
        <div style={{ fontSize: '12px' }}>
            Raised by assistant at:{' '}
            {dayjs.utc(data?.createdTime, 'YYYY-MM-DD HH:mm:ss')?.local()?.format('DD MMM, h:mma')}
          </div>
        <div style={{ textAlign: 'center' }}>{data?.clinicLocationName}</div>

        {/* starts time and fees */}
        <div
          style={{
            margin: '24px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div>
            Starts:
            {dayjs.utc(data?.startTime, 'YYYY-MM-DD HH:mm:ss')?.local()?.format('DD MMM, h:mma')}
          </div>
          <div>
            Fee: {currency_list?.find((item) => item?.code === data?.currency)?.symbol}
            {data?.fee}
          </div>

        </div>

        {/* Patient Details */}
        <div
          style={{
            margin: '24px 0',
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <ChatAvatarContainer
            backgroundImage={data?.patientProfilePicId && getImageLink(data?.patientProfilePicId)}
          >
            {data?.patientProfilePicId ? '' : getInitialsForChat(data?.patientName)}
          </ChatAvatarContainer>
          <div>
            <div>
              {getAgeFromDobWithTime(data?.patientDateOfBirth)},{' '}
              {GENDER_LIST_OFFLINE?.find((item) => item?.value === data?.patientGender)?.label}
              {Array.isArray(data?.patientLanguages) &&
                data?.patientLanguages?.length > 0 &&
                `, speaks ${data?.patientLanguages?.join(', ')}`}
            </div>
            <div>Ref: {data?.suggestedByMentorName}</div>
            {/* <div>Ask: NA</div> */}
          </div>
        </div>

        {data?.status === BOOKING_REQUEST_STATUS.BOOKING_CANCELLED && (
          <div className="text-center">
            <u>Request Cancelled</u>
          </div>
        )}
        {data?.status === BOOKING_REQUEST_STATUS.BOOKING_EXPIRED && (
          <div className="text-center">
            <u>Request Expired</u>
          </div>
        )}
        {data?.status === BOOKING_REQUEST_STATUS.BOOKING_REJECTED && (
          <div className="text-center">
            <u>Request Rejected by you.</u>
          </div>
        )}
        {data?.status === BOOKING_REQUEST_STATUS.BOOKING_ACCEPTED &&
          (profileData?.userId === data?.acceptedBy ? (
            <div className="text-center" style={{ color: 'red' }}>
              <u>Accepted by you. Booking not done. Contact support.</u>
            </div>
          ) : (
            <div className="text-center" style={{ color: 'red' }}>
              <u>Accepted by a provider. But booking not done. Contact support</u>
            </div>
          ))}
        {data?.status === BOOKING_REQUEST_STATUS.BOOKING_BOOKED &&
          (profileData?.userId === data?.acceptedBy ? (
            <div className="d-flex flex-column align-items-center justify-content-center">
              <div className="text-center" style={{ color: 'green', marginBottom: '16px' }}>
                <u>Booking created for you.</u>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => navigate('/mentor-home/my-calendar?view=booked')}
              >
                Check Bookings
              </button>
            </div>
          ) : (
            <div className="text-center" style={{ color: 'red' }}>
              <u>Booking accepted by a therapist.</u>
            </div>
          ))}

        {/* action buttons */}
        {data?.status === BOOKING_REQUEST_STATUS.BOOKING_INITIATED && (
          <MBRActionbuttonContainer>
            <MBRActionbutton
              successStyle={false}
              onClick={() => {
                if (!rejectLoading && !acceptLoading) {
                  rejectBookingRequest(data?.id)
                }
              }}
            >
              {rejectLoading ? (
                <Spinner animation="border" variant="dark" size="sm" />
              ) : (
                <CloseIcon style={{ color: '#FF0000', fontSize: '16px' }} />
              )}
            </MBRActionbutton>
            <MBRActionbutton
              successStyle={true}
              onClick={() => {
                if (!rejectLoading && !acceptLoading) {
                  acceptBookingRequest(data?.id)
                }
              }}
            >
              {acceptLoading ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (
                <DoneIcon style={{ color: '#FFF', fontSize: '28px' }} />
              )}
            </MBRActionbutton>
          </MBRActionbuttonContainer>
        )}

        {/* . */}
      </MBRItemInternalContainer>
    </MBRItemContainer>
  )
}

export const getFilteredTheBookingRequests = (rcvdBookingRequests) => {
  const existingData = [...rcvdBookingRequests]
  const latestEntries = {}
  existingData.forEach((brq) => {
    if (latestEntries.hasOwnProperty(brq?.id)) {
      if (
        dayjs(brq?.modifiedTime, 'YYYY-MM-DD HH:mm:ss').isAfter(
          dayjs(latestEntries[brq?.id]?.modifiedTime),
          'YYYY-MM-DD HH:mm:ss',
        )
      ) {
        latestEntries[brq?.id] = brq
      }
    } else {
      latestEntries[brq?.id] = brq
    }
  })
  return Object.values(latestEntries)
}

export const CloseButtonForBack = () => {
  const shouldShowButton = window.history.length > 2
  const navigate = useNavigate()

  return (
    <>
      {shouldShowButton ? (
        <div
          className="w-100 tracking-wide d-flex justify-content-end align-items-center"
          style={{ cursor: 'pointer', letterSpacing: '1px', background: 'gray', color: '#FFF' }}
          onClick={() => navigate('/')}
        >
          CLOSE <CloseIcon style={{ marginLeft: '4px' }} />
        </div>
      ) : (
        <div></div>
      )}
    </>
  )
}
